import { define } from 'wicked-elements'
import onIntersect from 'on-intersect'

define('[data-component~="auto-video"]', {
  init () {
    this.onIntersect = this.onIntersect.bind(this)
    this.togglePlay = this.togglePlay.bind(this)
  },
  connected () {
    this.element.addEventListener('click', this.togglePlay)
    this.stopObserving = onIntersect(this.element, this.onIntersect, this.onIntersect)
  },
  disconnected () {
    this.stopObserving()
  },
  onIntersect (e) {
    if (e.intersectionRatio === 0) {
      this.element.pause()
    } else {
      this.element.play()
    }
  },
  togglePlay () {
    if (this.element.paused) {
      this.element.play() 
    } else {
      this.element.pause()
    }
  }
})